import Api from '~/store/idonia-api/api.js'
import store from '~/store/store'
import useLanguageTree from '~/commons/language'
const {t} = useLanguageTree()

const REQUIRED_CONTRACTS = [
  'privacy_policy',
  'terms_and_conditions'
]

export default {
  namespaced: true,
  state: () => ({
    data: [],
    accepted: []
  }),
  mutations: {
    data (state, value) {
      state.data = value
    },
    accepted (state, value) {
      state.accepted = value
    }
  },
  actions: {
    async init ({ commit }) {
      const response = await Api.getV2('contracts')
      commit('data', response.data)
    },
    async loadAccepted ({ commit, dispatch }) {
      const response = await Api.getV2('account/contracts')
      commit('accepted', response.data)
      console.log(response)
      dispatch('triggerRequiredContracts')
      return response.data
    },
    async acceptContract ({ dispatch }, { name, version }) {
      const response = await Api.putV2(`account/contracts/${name}/accept`, { data: { version } })
      if (response.ok) {
        dispatch('loadAccepted')
      }
    },
    triggerRequiredContracts ({ state, dispatch }) {
      const required = state.data.filter(item => REQUIRED_CONTRACTS.includes(item.name))
      for (const contract of required) {
        const accepted = state.accepted.find(item => item.name === contract.name)
        if (accepted.outdated) {
          dispatch('openContractDialog', { contract, isUpdate: true })
          return
        }
      }
    },
    openContractDialog ({ getters, dispatch }, { contractName, contract, justForInfo = false, isUpdate = false, callback, disableCheckbox = false }) {
      contract = contractName ? getters['getContractByName'](contractName) : contract
      store.dispatch('dialog/showDialog', {
        type: 'contract',
        title: t(`contracts.${contract.name}.${isUpdate ? 'update_' : ''}title`),
        props: { contract, disableCheckbox },
        persistent: !justForInfo,
        actions: {
          accept: {
            title: justForInfo ? 'ok' : 'accept',
            callback: justForInfo
              ? undefined
              : callback || (async () => {
                await Api.putV2(`account/contracts/${contract.name}/accept`, {
                  data: { version: contract.version }
                })

                dispatch('loadAccepted')
              })
          }
        }
      })
    }
  },
  getters: {
    getContractByName: state => name => state.data.find(item => item.name === name)
  }
}



// WEBPACK FOOTER //
// ./src/store/idonia-api/contracts.js